import { Box, Checkbox } from '@mui/material';
import { styled } from '@mui/material/styles';

// Styled DataGrid container to allow button overflow
export const StyledDataGridContainer = styled(Box)`
  height: calc(100% - 64px);
  width: 100%;

  .MuiDataGrid-cell {
    overflow: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  // Permettre l'overflow seulement pour les colonnes de timeslots (qui contiennent les inputs avec boutons)
  .MuiDataGrid-cell[data-field^='timeSlot_'],
  .MuiDataGrid-cell[data-field='forecast'],
  .MuiDataGrid-cell[data-field='stock'],
  .MuiDataGrid-cell[data-field='toProduce'],
  .MuiDataGrid-cell[data-field='product'] {
    overflow: visible !important;
  }

  .MuiDataGrid-row {
    overflow: visible !important;
  }

  .MuiDataGrid-columnHeaders {
    overflow: visible !important;
    border-top: 1px solid #e3e3e2;
  }

  .MuiDataGrid-columnHeader {
    border-top: none;
    border-bottom: 1px solid #e3e3e2;
  }

  .MuiDataGrid-virtualScroller {
    overflow: scroll !important;
  }

  // Apply left spacing only when first timeslot forecast is focused
  // Selector for all non-pinned columns
  .MuiDataGrid-cell[data-field^='timeSlot_'] > *,
  .MuiDataGrid-cell[data-field='forecast'] > *,
  .MuiDataGrid-cell[data-field='stock'] > *,
  .MuiDataGrid-cell[data-field='toProduce'] > *,
  .MuiDataGrid-cell[data-field='product'] > * {
    margin-left: 0;
    transition: margin-left 0.2s ease-in-out;
  }

  .MuiDataGrid-columnHeader[data-field^='timeSlot_']:first-child,
  .MuiDataGrid-columnHeader[data-field='forecast']:first-child,
  .MuiDataGrid-columnHeader[data-field='stock']:first-child,
  .MuiDataGrid-columnHeader[data-field='toProduce']:first-child,
  .MuiDataGrid-columnHeader[data-field='product']:first-child {
    margin-left: 0;
    transition: margin-left 0.2s ease-in-out;
  }

  // Apply margin when first forecast is focused
  &[data-first-forecast-focused='true'] {
    .MuiDataGrid-cell[data-field^='timeSlot_'] > *,
    .MuiDataGrid-cell[data-field='forecast'] > *,
    .MuiDataGrid-cell[data-field='stock'] > *,
    .MuiDataGrid-cell[data-field='toProduce'] > *,
    .MuiDataGrid-cell[data-field='product'] > * {
      margin-left: 40px !important;
    }

    // Headers: different margin based on whether we have timeslots
    &[data-has-time-slots='true'] {
      .MuiDataGrid-columnHeader[data-field^='timeSlot_']:first-child {
        margin-left: 40px !important;
      }
    }

    &[data-has-time-slots='false'] {
      .MuiDataGrid-columnHeader[data-field='forecast']:first-child,
      .MuiDataGrid-columnHeader[data-field='stock']:first-child,
      .MuiDataGrid-columnHeader[data-field='toProduce']:first-child,
      .MuiDataGrid-columnHeader[data-field='product']:first-child {
        margin-left: 20px !important;
      }
    }
  }

  // Styles for the pagination footer - same design as SupplierProductsDatagrid
  & .MuiDataGrid-footerContainer {
    min-height: 48px;
    height: 48px;
    border-top: 1px solid ${({ theme }) => theme.colors.greys.light};
    background-color: ${({ theme }) => theme.colors.greys.lightest};
    justify-content: flex-start;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }

  & .MuiTablePagination-root {
    font-size: 14px;
  }

  & .MuiTablePagination-displayedRows {
    font-size: 14px;
    margin: 0;
  }

  & .MuiTablePagination-selectLabel {
    font-size: 14px;
    margin: 0;
  }

  & .MuiTablePagination-actions {
    margin-left: 8px;
  }
`;

export const StyledCheckbox = styled(Checkbox)(() => ({
  '& .MuiSvgIcon-root': {
    fontSize: 20,
  },
}));
